
import { Component, Vue, Prop, Watch, Provide } from 'vue-property-decorator';
import TopContentTitle from '@/components/TopContentTitle.vue';
import TopContentSentence from '@/components/TopContentSentence.vue';
import ScamAlertHeader from '@/components/scam_alert/ScamAlertHeader.vue';
import axios, { AxiosResponse } from 'axios';
import { KycOrgConfig } from '@/api/auth';
import ApiCancelError from '@/resources/error/ApiCancelError';
import ApiModalError from '@/resources/error/ApiModalError';
import FooterButton from '@/components/FooterButton.vue';
import { isPC } from '@/util/device';
import TopFooterButton from '@/components/TopFooterButton.vue';

const http = axios.create({ timeout: 30000 });

interface ScamAlertConfigRequest {
  kycOrgID: number;
  kycOrgCode: string;
  language: string;
}

interface ScamAlertConfigResponse {
  title: string;
  serviceName: string;
  message: string;
}

if (process.env.NODE_ENV === 'development') {
  const MockAdapter = require('axios-mock-adapter');
  const mock = new MockAdapter(http);
  const params = {
    kycOrgID: 999,
    kycOrgCode: '123',
    language: 'ja'
  };
  const response = {
    title: '他人から依頼された本人確認は\nすべて詐欺です',
    serviceName: 'サービス名',
    message:
      '“サービス名”の契約手続きにおける本人確認です。昨今、第三者の依頼で不正なサービス申し込みが増えております。第三者の依頼で本人確認をしないでください。'
  };

  mock.onGet(`${process.env.VUE_APP_API_ENDPOINT}/unauthorized/scam_alert/config`).reply(200, response);
  mock
    .onGet(`${process.env.VUE_APP_API_ENDPOINT}/unauthorized/scam_alert/config`, {
      params: {
        ...params,
        language: 'id'
      }
    })
    .reply(200, {
      ...response,
      serviceName: 'id'
    });
}

@Component({
  components: {
    ScamAlertHeader,
    TopContentTitle,
    TopContentSentence,
    TopFooterButton,
    FooterButton
  }
})
export default class ScamAlert extends Vue {
  public isLastLoading: boolean = false;
  public title: string = '';
  public serviceName: string = '';
  public message: string = '';

  @Provide() isPC = isPC;

  @Prop({ type: Number, required: true })
  public kycOrgId!: string;

  @Prop({ type: String, required: true })
  public kycOrgCode!: number;

  @Prop({ type: String, required: true })
  public language!: string;

  @Prop({ type: Boolean, default: false })
  public isApp!: boolean;

  @Watch('language')
  public onLanguageChanged(): void {
    this.fetchMessages();
  }

  private fetchMessages() {
    http
      .get<ScamAlertConfigRequest, AxiosResponse<ScamAlertConfigResponse>>(
        `${process.env.VUE_APP_API_ENDPOINT}/unauthorized/scam_alert/config`,
        {
          params: {
            kycOrgID: this.kycOrgId,
            kycOrgCode: this.kycOrgCode,
            language: this.language
          }
        }
      )
      .then(({ data: { title, serviceName, message } }) => {
        this.title = title;
        this.serviceName = serviceName;
        this.message = message;
      });
  }

  async created(): Promise<void> {
    this.fetchMessages();
  }

  public async next(): Promise<void> {
    try {
      this.isLastLoading = true;

      if (this.$store.getters['auth/kycOrgConfigBirthAuth']) {
        this.$router.push({ name: 'birthday' });
        return;
      }

      // 利用規約にすでに同意している
      const checkTermsOfService: KycOrgConfig = this.$store.getters['auth/kycOrgConfigCheckTermsOfService'];
      const agreedTermsOfService: boolean = this.$store.getters['terms/agreedTermsOfService'];
      if (!checkTermsOfService || agreedTermsOfService) {
        this.$router.push('/top/personal-information');
        return;
      }

      this.$router.push({ name: 'terms' });
    } catch (error) {
      if (error instanceof ApiCancelError) {
        // キャンセルは握りつぶす
      } else if (error instanceof ApiModalError) {
        // clientRetryableで処理したエラーは握りつぶす
      } else throw error;
    } finally {
      this.isLastLoading = false;
    }
  }
}
